import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { URLS } from '@shared/constants';
import {
  CommonResponseDTO,
  IRoleResponse,
  IWidget,
  IWidgetEndpointResponse,
  IWidgetLayout,
  IWidgetUserLayout,
} from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class WidgetApiService {
  constructor(private http: HttpClient) {}

  getAllWidgets(): Observable<CommonResponseDTO<IWidget[]>> {
    return this.http.get<CommonResponseDTO<IWidget[]>>(URLS.WIDGETS);
  }

  getSingleWidget(id: string): Observable<CommonResponseDTO<IWidget>> {
    const url = `${URLS.WIDGETS}/${id}`;
    return this.http.get<CommonResponseDTO<IWidget>>(url);
  }

  getCurrentUserWidgetLayout(): Observable<
    CommonResponseDTO<IWidgetUserLayout>
  > {
    const url = `${URLS.WIDGET_LAYOUT}/user`;
    return this.http.get<CommonResponseDTO<IWidgetUserLayout>>(url);
  }

  getUserIdentityWidgetLayout(): Observable<
    CommonResponseDTO<IWidgetUserLayout>
  > {
    const url = `${URLS.WIDGET_LAYOUT}/identity`;
    return this.http.get<CommonResponseDTO<IWidgetUserLayout>>(url);
  }

  getRoleWidgetLayout(
    id: string
  ): Observable<CommonResponseDTO<IWidgetUserLayout>> {
    const url = `${URLS.WIDGET_LAYOUT}/roles/${id}`;
    return this.http.get<CommonResponseDTO<IWidgetUserLayout>>(url);
  }

  updateOrCreateLayout(
    data: IWidgetLayout
  ): Observable<CommonResponseDTO<IWidgetLayout>> {
    return this.http.patch<CommonResponseDTO<IWidgetLayout>>(
      URLS.WIDGET_LAYOUT,
      data
    );
  }

  updateOrCreateMyCollectionLayout(
    data: IWidgetLayout
  ): Observable<CommonResponseDTO<IWidgetLayout>> {
    const url = `${URLS.WIDGET_LAYOUT}/my-collection`;
    return this.http.patch<CommonResponseDTO<IWidgetLayout>>(url, data);
  }

  getAllRoles(): Observable<CommonResponseDTO<IRoleResponse[]>> {
    const url = `${URLS.WIDGET_LAYOUT}/roles`;
    return this.http.get<CommonResponseDTO<IRoleResponse[]>>(url);
  }

  getAllRolesForPersonalization(): Observable<
    CommonResponseDTO<IRoleResponse[]>
  > {
    const url = `${URLS.WIDGET_LAYOUT}/personalization`;
    return this.http.get<CommonResponseDTO<IRoleResponse[]>>(url);
  }

  getWidgetData(
    url: string,
    config?: HttpParams
  ): Observable<CommonResponseDTO<IWidgetEndpointResponse>> {
    const demoUrl = `${url}`;
    const params = config;
    return this.http.get<CommonResponseDTO<IWidgetEndpointResponse>>(demoUrl, {
      params,
    });
  }

  getConfigTypeWidgetData(
    url: string,
    config?: string
  ): Observable<CommonResponseDTO<IWidgetEndpointResponse>> {
    const demoUrl = `${url}/${config}`;

    return this.http.get<CommonResponseDTO<IWidgetEndpointResponse>>(demoUrl);
  }
}
